import { Component, OnInit, Inject, ElementRef, ViewChild } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { MatSnackBar } from '@angular/material/snack-bar';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { MtxDialogData } from '@ng-matero/extensions';
import { ChargerService } from 'app/shared/services/charger/charger.service';
import { DateService } from 'app/shared/services/utility/date.service';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { MatSort } from '@angular/material/sort';
import {ChargingStationService} from 'app/shared/services/charging-station/charging-station.service'
import {Observable} from 'rxjs';
import {map, startWith} from 'rxjs/operators';
export interface Configuration{
  key: string;
 
  
}
@Component({
  selector: 'app-change-configuration-shared-dialog',
  templateUrl: './change-configuration-shared-dialog.component.html',
  styleUrls: ['./change-configuration-shared-dialog.component.scss']
})
export class ChangeConfigurationSharedDialogComponent implements OnInit {

  params: any;
  isEditMode = false;
  form: FormGroup;
  localStorage : any;
  status = false;
  
  batches:any;
  stations:any;
  versions :any;
  isAvailable = false;
  panelOpenState = false;
  minTDate : any;
  currDate : any = new Date();
  isConfigEdit = false;
    configurationData: Configuration[] = [
      { key: 'AllowOfflineTxForUnknownId' },
      { key: 'AuthorizationCacheEnabled'},
      { key: 'AuthorizeRemoteTxRequests',},
      {	key: 'ClockAlignedDataInterval'},
      { key: 'ConnectionTimeOut'},
      {	key: 'GetConfigurationMaxKeys'},
      {	key: 'HeartbeatInterval'},
      {	key: 'LocalAuthorizeOffline'},
      {	key: 'LocalPreAuthorize'},
      {	key: 'MeterValuesAlignedData'},
      {	key: 'MeterValuesAlignedDataMaxLength'},
      {	key: 'MeterValuesSampledData'},
      {	key: 'MeterValuesSampledDataMaxLength'},
      {	key: 'MeterValueSampleInterval'},
      {	key: 'MinimumStatusDuration'},
      {	key: 'NumberOfConnectors'},
      {	key: 'ResetRetries'},
      {	key: 'ConnectorPhaseRotation'},
      {	key: 'ConnectorPhaseRotationMaxLength'},
      {	key: 'StopTransactionOnEVSideDisconnect'},
      {	key: 'StopTransactionOnInvalidId'},
      {	key: 'StopTxnAlignedData'},
      {	key: 'StopTxnAlignedDataMaxLength'},
      {	key: 'StopTxnSampledData'},
      {	key: 'StopTxnSampledDataMaxLength'},
      {	key: 'SupportedFeatureProfiles'},
      {	key: 'SupportedFeatureProfilesMaxLength'},
      {	key: 'TransactionMessageAttempts'},
      {	key: 'TransactionMessageRetryInterval'},
      {	key: 'UnlockConnectorOnEVSideDisconnect'},
      {	key: 'LocalAuthListEnabled'},
      {	key: 'LocalAuthListMaxLength'},
      {	key: 'SendLocalListMaxLength'},
      {	key: 'defaultIDTag'},
      {	key: 'OpenChargeModeEnable'},
      {	key: 'WebSocketPingInterval'},
      {	key: 'BlinkRepeat'},
      {	key: 'LightIntensity'},
      {	key: 'MaxEnergyOnlinevalidId'},
      {	key: 'ChargeProfileMaxStackLevel'},
      {	key: 'ReserveConnectorZeroSupported'},
      {	key: 'ChargingScheduleAllowedChargingRateUnit'},
      {	key: 'ChargerScheduleMaxPeriods'},
      {	key: 'ConnectorSwitch3To1PhaseSupport'},
      {	key: 'MaxChargeProfilesInstalled'},
      {	key: 'APN',},
      {	key: 'OCPPBackendJSONURL'},
      {	key: 'ChargeBoxIdentity'},
      {	key: 'ICCID'},
      {	key: 'IMSI'},
      {	key: 'OTPSupport'}
     ];
     filteredOptionsChangeKey: Observable<any>;
     dataTypeList :any;
     boolenaType:boolean = false;
     numberType:boolean = false;
     stringType:boolean = false;
     alfanumeric:boolean = false;
  constructor(private fb: FormBuilder,
   private chargerService : ChargerService,
    private dateService : DateService,
    private snackBar: MatSnackBar,
     private chargingStationService: ChargingStationService,
    public dialogRef: MatDialogRef<ChangeConfigurationSharedDialogComponent>, @Inject(MAT_DIALOG_DATA) public data: MtxDialogData) {}

  ngOnInit() {
  
    this.initialize();

    //this.getConfiguration();
  }

  initialize(){

    this.localStorage = JSON.parse( localStorage.getItem('userDetails'));

    this.params = this.data;
    this.getDataTypes();
    if(this.params.data.isConfigEdit == false){
      this.getConfiguration(this.params);
    
    }
    
    // this.isEditMode = this.params.action == 'CREATE' ? false : true;
   var flag = this.params.data.isConfigEdit;
    this.form = this.fb.group({
      key: [{value:'',disabled:flag},[Validators.required] ],
      cValue: [{value:'',disabled:flag}, [Validators.required]],
      newValue: ['', [Validators.required]],
      
    });

    
   
    // if (this.isEditMode){
      this.assignValues(this.params);
      this.isConfigEdit = this.params.data.isConfigEdit;
     
    // }
  }

  getConfiguration(parmas){
    let params = {
      command: "GET_CONFIGURATION",
      charger_id: parmas.chargerObj.name,
      charger_sr_no: parmas.chargerObj.serial_no,
      connector: parmas.connector.connector_no,
      value: '',
      key: ''
    }
    this.chargingStationService.getConfiguration(params).subscribe((data: any) => {
      //
      //this.logs = data;
      this.configurationData = data.data;
      this.filteredOptionsChangeKey = this.form.controls.key.valueChanges
      .pipe(
        startWith(''),
        map(value => typeof value === 'string' ? value : value.name),
        map(name => name ? this._filterChangeKey(name) : this.configurationData)
      ); 
      //this.downClick();
     // this.upClick();
      //;
      //this.snackBar.open(data.message, 'Dismiss', { duration: 3000 });
    }, (err) => {
      this.snackBar.open(err, 'Dismiss', { duration: 3000 });

    })
  }
  getDataTypes(){
   
    this.chargingStationService.getChargerConfigurationKeys().subscribe((resp: any) => {
      //
      //this.logs = data;
      this.dataTypeList = resp.data;
      if(this.params.data.key != undefined){
        const toSelect = this.dataTypeList.find(c => c.name == this.params.data.key);
      
        if(toSelect !=null){
          if (toSelect.data_type == 'BOOLEAN'){
                    this.boolenaType= true;
                    this.numberType = false;
                    this.stringType = false;
                    this.alfanumeric = false;
                }else if(toSelect.data_type == 'NUMERIC'){
                    this.numberType = true;
                    this.stringType = false;
                    this.boolenaType =false;
                    this.alfanumeric = false;
                }else if(toSelect.data_type == 'STRING'){
                    this.stringType = true;
                    this.numberType = false;
                    this.boolenaType = false;
                    this.alfanumeric = false;
                }else if(toSelect.data_type == 'ALPHANUMERIC'){
                  this.stringType = false;
                  this.numberType = false;
                  this.boolenaType = false;
                  this.alfanumeric = true;
                }
        }
        // for(var i= 0; i<= this.dataTypeList.length;i++){
        //   if(this.params.data.key == this.dataTypeList[i].name){
        //     if (this.dataTypeList[i].data_type == 'BOOLEAN'){
        //         this.boolenaType= true;
        //         this.numberType = false;
        //         this.stringType = false;
        //     }else if(this.dataTypeList[i].data_type == 'NUMERIC'){
        //         this.numberType = true;
        //         this.stringType = false;
        //         this.boolenaType =false;
        //     }else if(this.dataTypeList[i].data_type == 'STRING'){
        //         this.stringType = true;
        //         this.numberType = false;
        //         this.boolenaType = false;
        //     }
        //   }
        // }
      }
      
    }, (err) => {
      this.snackBar.open(err, 'Dismiss', { duration: 3000 });
    })
  }


 
  close() {
    this.dialogRef.close();
  }


  

  assignValues(params){
    
    this.form.get('key').setValue(params.data.key);
    this.form.get('cValue').setValue(params.data.value);  
    this.form.get('newValue').setValue(params.data.newValue);
  }

  getNewConfiguration(){
    this.dialogRef.afterClosed().subscribe(res => {
    })
    this.dialogRef.close(this.form.value);
  }
  displayChangeKey(configurationData: Configuration): string {
    return configurationData && configurationData ? configurationData.key : '';
  }

  private _filterChangeKey(name: string): Configuration[] {
    const filterCMDValue = name.toLowerCase();

    return this.configurationData.filter(option => option.key.toLowerCase().indexOf(filterCMDValue) === 0);
  }
  onKeyChange(key){
    
    for(var i= 0; i< this.dataTypeList.length;i++){
      if(key == this.dataTypeList[i].name){
        if (this.dataTypeList[i].data_type == 'BOOLEAN'){
          this.boolenaType= true;
          this.numberType = false;
          this.stringType = false;
        }else if(this.dataTypeList[i].data_type == 'NUMERIC'){
          this.numberType = true;
          this.stringType = false;
          this.boolenaType =false;
        }else if(this.dataTypeList[i].data_type == 'STRING'){
          this.stringType = true;
          this.numberType = false;
          this.boolenaType = false;
        }
      }
    }
  }
}






